/*eslint-disable*/
import Vue from "vue"
import Router from "vue-router"


/*page*/
import home from '@/pages/home/home.vue'  //首页
import productPage from '@/pages/product/product.vue'  //产品列表
import userIndex from '@/pages/user/userIndex.vue'  //个人中心首页
import kefuPage from '@/pages/kefu/kefu.vue'  //客服
import qqTans from '@/pages/kefu/qqTans.vue'  //客服浏览器兼容
import loginPage from '@/pages/user/login.vue'  //登录
import registerPage from '@/pages/user/register.vue'  //注册
import aboutPage from '@/pages/about/about.vue'  //关于我们

import productDzyccl from '@/pages/product/product-dzyccl.vue'
import productGszc from '@/pages/product/product-gszc.vue'  //公司注册
import productGszx from '@/pages/product/product-gszx.vue'
import productKzba from '@/pages/product/product-kzba.vue'
import productNdgsnb from '@/pages/product/product-ndgsnb.vue'
import productNdhsqj from '@/pages/product/product-ndhsqj.vue'
import productQybg from '@/pages/product/product-qybg.vue'
import productXggszc from '@/pages/product/product-xggszc.vue'
import productXggszx from '@/pages/product/product-xggszx.vue'

import productKsjbh from '@/pages/product/product-ksjbh.vue'
import productSbkh from '@/pages/product/product-sbkh.vue'
import productKsybh from '@/pages/product/product-ksybh.vue'
import productKsgjjzh from '@/pages/product/product-ksgjjzh.vue'
import productDljz from '@/pages/product/product-dljz.vue'
import productSwch from '@/pages/product/product-swch.vue'
import productCszx from '@/pages/product/product-cszx.vue'  //财税咨询
import productDzdjzfa from '@/pages/product/product-dzdjzfa.vue'
import productSwjf from '@/pages/product/product-swjf.vue'
import productKpzx from '@/pages/product/product-kpzx.vue'
import productJzsl from '@/pages/product/product-jzsl.vue'
import productNbycjf from '@/pages/product/product-nbycjf.vue'
import productFpsl from '@/pages/product/product-fpsl.vue'
import productWqsmfw from '@/pages/product/product-wqsmfw.vue'
import productSpjyxkz from '@/pages/product/product-spjyxkz.vue'
import productDskfwb from '@/pages/product/product-dskfwb.vue'
import productJwtz from '@/pages/product/product-jwtz.vue'
import productLwpqxkz from '@/pages/product/product-lwpqxkz.vue'
import productYxcbyyba from '@/pages/product/product-yxcbyyba.vue'
import productDlysxkz from '@/pages/product/product-dlysxkz.vue'
import productMeal from '@/pages/product/product-meal.vue'


import agreement from '@/pages/user/agreement.vue'  //协议
import baseMessage from '@/pages/user/baseMessage.vue'  //个人信息
import qqChange from '@/pages/user/qqChange.vue'  //qq号更改
import passwordChange from '@/pages/user/password.vue'

import phoneChange from '@/pages/user/phone.vue'   
import findPassword from '@/pages/user/findPassword.vue'  //找回密码
import mineTiwen from '@/pages/problem/mineTiwen.vue'  //我的提问
import wenDetail from '@/pages/problem/wenDetail.vue'  //我的提问详情
import tousuPage from '@/pages/problem/tousu.vue'  //投诉
import tousuDetail from '@/pages/problem/tousuDetail.vue'  //投诉详情
import cjWen from '@/pages/problem/cjWen.vue'  //常见问题
import cjDetail from '@/pages/problem/cjDetail.vue'  //常见问题详情
import wyTiwen from '@/pages/problem/wyTiwen.vue'  //我要提问
import wyTousu from '@/pages/problem/wyTousu.vue'  //我要投诉


import zixunPage from '@/pages/news/zixun.vue'  //行业资讯
import zxDetail from '@/pages/news/zxDetail.vue'  //咨询详情


import orderList from '@/pages/order/orderList.vue'  //订单列表
import orderDetail from '@/pages/order/orderDetail.vue'  //订单详情
import paySure from '@/pages/order/paySure.vue'  //确认支付

import errorPage from '@/pages/error/error.vue'  //错误页面404 500


//推广页面
import extension from '@/pages/extension/extension.vue'  
//隐私政策
import policy from '@/pages/extension/policy.vue' 


Vue.use(Router);

export default new Router({
	mode: 'history',  //去掉url中的#
	base:'/',
	scrollBehavior: () => ({ y: 0 }),
	routes:[
	    {
			path:'/',
			component:home,
			name:'homePage',
			meta:{title:'首页'}
		},
		{
			path:'/product',
			component:productPage,
			name:'productPage',
			meta:{title:'产品列表'},
		},
		{
			path:'/about',
			component:aboutPage,
			name:'aboutPage',
			meta:{title:'关于我们'},
		},
		{
			path:'/kefu/:time',
			component:kefuPage,
			name: 'kefuPage'
		},
		{
			path:'/qqTans',
			component:qqTans,
			name:'qqTans',
			meta:{title:'友情提示'},
		},
		{
			path:'/agreement',
			component:agreement,
			name:'agreement',
			meta:{title:'零分享服务协议'},
		},	
		{
			path:'/meal/product-meal/:id',
			component:productMeal,
			name:'productMeal',
			meta:{title:'套餐组合'},
		},
		{
			path:'/errorPage',
			component:errorPage,
			name:'errorPage',
			meta:{title:'页面出错了'},
		},
		{
			path:'/product/product-gszc',
			component:productGszc,
			name:'productGszc',		
			meta:{title:'公司注册'},
		},
		{
			path:'/product/product-gszc/:pid',
			component:productGszc,
			name:'againGszc',		
			meta:{title:'公司注册'},
		},
		{
			path:'/product/product-dzyccl',
			component:productDzyccl,
			name:'productDzyccl',
			meta:{title:'地址异常处理'},
		},
		{
			path:'/product/product-dzyccl/:pid',
			component:productDzyccl,
			name:'againDzyccl',
			meta:{title:'地址异常处理'},
		},
		{
			path:'/product/product-gszx',
			component:productGszx,
			name:'productGszx',	
			meta:{title:'公司注销'},
		},
		{
			path:'/product/product-gszx/:pid',
			component:productGszx,
			name:'againGszx',	
			meta:{title:'公司注销'},
		},
		{
			path:'/product/product-kzba',
			component:productKzba,
			name:'productKzba',	
			meta:{title:'刻章备案'},	
		},
		{
			path:'/product/product-kzba/:pid',
			component:productKzba,
			name:'againKzba',	
			meta:{title:'刻章备案'},	
		},
		{
			path:'/product/product-ndgsnb',
			component:productNdgsnb,
			name:'productNdgsnb',	
			meta:{title:'年度工商年报'},		
		},
		{
			path:'/product/product-ndgsnb/:pid',
			component:productNdgsnb,
			name:'againNdgsnb',	
			meta:{title:'年度工商年报'},		
		},
		{
			path:'/product/product-ndhsqj',
			component:productNdhsqj,
			name:'productNdhsqj',	
			meta:{title:'年度汇算清缴'},		
		},
		{
			path:'/product/product-ndhsqj/:pid',
			component:productNdhsqj,
			name:'againNdhsqj',	
			meta:{title:'年度汇算清缴'},		
		},
		{
			path:'/product/product-qybg',
			component:productQybg,
			name:'productQybg',		
			meta:{title:'企业变更'},	
		},
		{
			path:'/product/product-qybg/:pid',
			component:productQybg,
			name:'againQybg',		
			meta:{title:'企业变更'},	
		},
		{
			path:'/product/product-xggszc',
			component:productXggszc,
			name:'productXggszc',	
			meta:{title:'香港公司注册'},		
		},
		{
			path:'/product/product-xggszc/:pid',
			component:productXggszc,
			name:'againXggszc',	
			meta:{title:'香港公司注册'},		
		},
		{
			path:'/product/product-xggszx',
			component:productXggszx,
			name:'productXggszx',		
			meta:{title:'香港公司注销'},	
		},
		{
			path:'/product/product-xggszx/:pid',
			component:productXggszx,
			name:'againXggszx',		
			meta:{title:'香港公司注销'},	
		},
		{
			path:'/product/product-ksjbh',
			component:productKsjbh,
			name:'productKsjbh',	
			meta:{title:'开设基本户'},		
		},
		{
			path:'/product/product-ksjbh/:pid',
			component:productKsjbh,
			name:'againKsjbh',	
			meta:{title:'开设基本户'},		
		},
		{	
			path:'/product/product-sbkh',
			component:productSbkh,
			name:'productSbkh',	
			meta:{title:'社保开户'},		
		},
		{
			path:'/product/product-sbkh/:pid',
			component:productSbkh,
			name:'againSbkh',	
			meta:{title:'社保开户'},		
		},
		{
			path:'/product/product-ksybh',
			component:productKsybh,
			name:'productKsybh',		
			meta:{title:'开设一般户'},	
		},
		{
			path:'/product/product-ksybh/:pid',
			component:productKsybh,
			name:'againKsybh',		
			meta:{title:'开设一般户'},	
		},
		{
			path:'/product/product-ksgjjzh',
			component:productKsgjjzh,
			name:'productKsgjjzh',	
			meta:{title:'开设公积金账户'},		
		},
		{
			path:'/product/product-ksgjjzh/:pid',
			component:productKsgjjzh,
			name:'againKsgjjzh',	
			meta:{title:'开设公积金账户'},		
		},
		{
			path:'/product/product-dljz',
			component:productDljz,
			name:'productDljz',		
			meta:{title:'代理记账'},	
		},
		{
			path:'/product/product-dljz/:pid',
			component:productDljz,
			name:'againDljz',		
			meta:{title:'代理记账'},	
		},
		{
			path:'/product/product-swch',
			component:productSwch,
			name:'productSwch',	
			meta:{title:'税务筹划'},		
		},
		{
			path:'/product/product-swch/:pid',
			component:productSwch,
			name:'againSwch',	
			meta:{title:'税务筹划'},		
		},
		{
			path:'/product/product-cszx',
			component:productCszx,
			name:'productCszx',			
			meta:{title:'财税咨询'},
		},
		{
			path:'/product/product-cszx/:pid',
			component:productCszx,
			name:'againCszx',		
			meta:{title:'财税咨询'},
		},
		{
			path:'/product/product-dzdjzfa',
			component:productDzdjzfa,
			name:'productDzdjzfa',		
			meta:{title:'定制代记账方案'},	
		},
		{
			path:'/product/product-dzdjzfa/:pid',
			component:productDzdjzfa,
			name:'againDzdjzfa',		
			meta:{title:'定制代记账方案'},	
		},
		{
			path:'/product/product-swjf',
			component:productSwjf,
			name:'productSwjf',		
			meta:{title:'税务解非'},	
		},
		{
			path:'/product/product-swjf/:pid',
			component:productSwjf,
			name:'againSwjf',		
			meta:{title:'税务解非'},	
		},
		{
			path:'/product/product-kpzx',
			component:productKpzx,
			name:'productKpzx',		
			meta:{title:'开票咨询'},	
		},
		{
			path:'/product/product-kpzx/:pid',
			component:productKpzx,
			name:'againKpzx',		
			meta:{title:'开票咨询'},	
		},
		{
			path:'/product/product-jzsl',
			component:productJzsl,
			name:'productJzsl',		
			meta:{title:'旧账梳理'},	
		},
		{
			path:'/product/product-jzsl/:pid',
			component:productJzsl,
			name:'againJzsl',		
			meta:{title:'旧账梳理'},	
		},
		{
			path:'/product/product-nbycjf',
			component:productNbycjf,
			name:'productNbycjf',	
			meta:{title:'年报异常解非'},	
		},
		{
			path:'/product/product-nbycjf/:pid',
			component:productNbycjf,
			name:'againNbycjf',	
			meta:{title:'年报异常解非'},	
		},
		{
			path:'/product/product-fpsl',
			component:productFpsl,
			name:'productFpsl',			
			meta:{title:'发票申领'},
		},
		{
			path:'/product/product-fpsl/:pid',
			component:productFpsl,
			name:'againFpsl',			
			meta:{title:'发票申领'},
		},
		{
			path:'/product/product-wqsmfw',
			component:productWqsmfw,
			name:'productWqsmfw',		
			meta:{title:'外勤上门服务'},	
		},
		{
			path:'/product/product-wqsmfw/:pid',
			component:productWqsmfw,
			name:'againWqsmfw',		
			meta:{title:'外勤上门服务'},	
		},
		{
			path:'/product/product-spjyxkz',
			component:productSpjyxkz,
			name:'productSpjyxkz',
			meta:{title:'食品经营许可证'},		
		},
		{
			path:'/product/product-spjyxkz/:pid',
			component:productSpjyxkz,
			name:'againSpjyxkz',
			meta:{title:'食品经营许可证'},		
		},
		{
			path:'/product/product-dskfwb',
			component:productDskfwb,
			name:'productDskfwb',	
			meta:{title:'电商客服外包'},	
		},
		{
			path:'/product/product-dskfwb/:pid',
			component:productDskfwb,
			name:'againDskfwb',	
			meta:{title:'电商客服外包'},	
		},
		{
			path:'/product/product-jwtz',
			component:productJwtz,
			name:'productJwtz',		
			meta:{title:'ODI境外投资'},	
		},
		{
			path:'/product/product-jwtz/:pid',
			component:productJwtz,
			name:'againJwtz',		
			meta:{title:'ODI境外投资'},	
		},
		{
			path:'/product/product-lwpqxkz',
			component:productLwpqxkz,
			name:'productLwpqxkz',	
			meta:{title:'劳务派遣许可证'},		
		},
		{
			path:'/product/product-lwpqxkz/:pid',
			component:productLwpqxkz,
			name:'againLwpqxkz',	
			meta:{title:'劳务派遣许可证'},		
		},
		{
			path:'/product/product-yxcbyyba',
			component:productYxcbyyba,
			name:'productYxcbyyba',
			meta:{title:'游戏出版运营备案'},		
		},
		{
			path:'/product/product-yxcbyyba/:pid',
			component:productYxcbyyba,
			name:'againYxcbyyba',
			meta:{title:'游戏出版运营备案'},		
		},
		{
			path:'/product/product-dlysxkz',
			component:productDlysxkz,
			name:'productDlysxkz',
			meta:{title:'道路运输许可证'},		
		},
		{
			path:'/product/product-dlysxkz/:pid',
			component:productDlysxkz,
			name:'againDlysxkz',
			meta:{title:'道路运输许可证'},		
		},
		{
			path:'/user/userIndex',
			component:userIndex,
			name:'userIndex',
			meta:{title:'个人中心'}
		},
		{
			path:'/user/userInfo',
			component:baseMessage,
			name:'baseMessage',
			meta:{title:'基本信息'}
		},
		{
			path:'/news/newsInfo',
			component:zixunPage,
			name:'zixunPage',
			meta:{title:'行业资讯'}
		},
		{
			path:'/news/newsInfo/:id',
			component:zxDetail,
			name:'zxDetail',
			meta:{title:'资讯详情'}
		},
		{
			path:'/user/updateQQ',
			component:qqChange,
			name:'qqChange',
			meta:{title:'QQ'}
		},
		{
			path:'/user/updatePwd',
			component:passwordChange,
			name:'passwordChange',
			meta:{title:'密码'}
		},
		{
			path:'/user/updatePhone',
			component:phoneChange,
			name:'phoneChange',
			meta:{title:'修改手机号'}
		},
		{
			path:'/problem/common',
			component:cjWen,
			name:'cjWen',
			meta:{title:'常见问题'}
		},
		{
			path:'/problem/commonInfo/:id',
			component:cjDetail,
			name:'cjDetail',
			meta:{title:'问题详情'}
		},
		{
			path:'/problem/mineTiwen',
			component:mineTiwen,
			name:'mineTiwen',
			meta:{title:'我的提问'}
		},
		{
			path:'/problem/wyTiwen',
			component:wyTiwen,
			name:'wyTiwen',
			meta:{title:'我要提问'}
		},
		{
			path:'/problem/wenDetail/:id',
			component:wenDetail,
			name:'wenDetail',
			meta:{title:'问题详情'}
		},
		{
			path:'/problem/tousu',
			component:tousuPage,
			name:'tousuPage',
			meta:{title:'我的投诉'}
		},
		{
			path:'/problem/wyTousu',
			component:wyTousu,
			name:'wyTousu',
			meta:{title:'我要投诉'}
		},
		{
			path:'/problem/tousuDetail/:id',
			component:tousuDetail,
			name:'tousuDetail',
			meta:{title:'投诉详情'}
		},
		{
			path:'/login',
			component:loginPage,
			name:'loginPage',
			meta:{title:'登录'}
		},
		{
			path:'/register',
			component:registerPage,
			name:'registerPage',
			meta:{title:'注册账号'}
		},
		{
			path:'/findPwd',
			component:findPassword,
			name:'findPassword',
			meta:{title:'找回密码'}
		},
		{
			path:'/order/orderInfo',
			component:orderList,
			name:'orderList',
			meta:{title:'我的订单'}
		},
		{
			path:'/order/orderInfo/:orderNo',
			component:orderDetail,
			name:'orderDetail',
			meta:{title:'订单详情'}
		},
		{
			path:'/order/paySure/:orderNo',
			component:paySure,
			name:'paySure',
			meta:{title:'支付确认'}
		},
		{
			path:'/extension',
			component:extension,
			name:'extension',
			meta:{title:'推广H5页面'}
		},
		{
			path:'/policy',
			component:policy,
			name:'policy',
			meta:{title:'隐私政策'}
		},
 ]
})